import React from "react";

import ModalContainer from "components/common/ModalContainer";
import { useMergedSearchParams } from "helpers/mergeSearchParams";
import ChatUIComponent from "../CommonChatComponent";

const SalesTargetAgent = ({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const { updateSearchParams } = useMergedSearchParams();

    return (
        <div className="">
            <ModalContainer
                open={open}
                modalClassName={"py-10 px-10"}
                tailwindClassName="!max-w-[1024px] !overflow-y-clip"
                showCloseIcon={false}
                closeModal={() => {
                    setOpen(false);
                    updateSearchParams({
                        updated: "true",
                    });
                }}
            >
                <ChatUIComponent
                    open={open}
                    setOpen={setOpen}
                    pageType="salesAgent"
                />
            </ModalContainer>
        </div>
    );
};

export default SalesTargetAgent;
